import './FlightInformation.scss';
import { Dispatch, SetStateAction } from 'react';
import { Field  } from '../../models/home';
import { handleOnChangeDate, handleOnChangeText, handleOnValidateDate } from '../../helpers/form';
import { useTranslation } from 'react-i18next';
import { VALIDATION_TYPE } from '../../constants/common';
import AppDate from '../AppCommon/AppDate/AppDate';
import AppText from '../AppCommon/AppText/AppText';

interface Props {
    fields: Field[];
    showPlaceholder: boolean;
    setFields: Dispatch<SetStateAction<Field[]>>;
    setShowPlaceholder: Dispatch<SetStateAction<boolean>>;
}

const FlightInformation = ({fields, showPlaceholder, setFields, setShowPlaceholder}: Props) => {
    const { t } = useTranslation();

    /* Enable 2 days prior to current date for selection */
    const minDate = new Date();
    minDate.setDate(minDate.getDate() - 2);

    return (
        <div className="c-flight-info">
            <div className="c-flight-num">
                {showPlaceholder && <span className="label" >AC</span>}
                <AppText
                    label={t('labels.flightNumber')}
                    width={100}
                    about='flightNumber'
                    helperText={fields[0].requiredError ? fields[0].requiredError : 'e.g. AC1234'}
                    error={fields[0].requiredError ? true : false}
                    maxLength={4}
                    value={fields[0].value}
                    onBlur={e => !e.target.value && setShowPlaceholder(false)}
                    onChange={e => handleOnChangeText(e, 0, setFields, VALIDATION_TYPE.numeric)}
                    onFocus={() => setShowPlaceholder(true)}
                />
            </div>
            <AppDate
                label={t('labels.date')}
                width={100}
                value={fields[1].value}
                onChange={e => handleOnChangeDate(e, 1, setFields)}
                error={fields[1].error || fields[1].requiredError ? true : false}
                helperText={fields[1].error ? fields[1].error : fields[1].requiredError ? fields[1].requiredError : 'DD/MM/YYYY'}
                minDate={minDate}
                onError={e => handleOnValidateDate(e, 1, setFields, t('validations.date'))}
            />
        </div>
    );
};

export default FlightInformation;